import React from 'react';
import {Text, View, PixelRatio} from 'react-native';
import {Props} from './model';
import {useStyles} from '../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../shared/theme/helpers';

export default ({eCardInfo}: Props) => {
  const styles = useStyles(({theme, isDesktop, mediaOnly}) => ({
    container: {
      backgroundColor: theme.color.primaryNonGreyBackground,
      borderWidth: 1,
      borderColor: theme.color.borderColor,
      borderStyle: 'solid',
      borderRadius: 5,
      ...mediaOnly(
        DeviceSize.desktop,
        {
          paddingTop: 36,
          paddingBottom: 40,
          paddingHorizontal: 30,
        },
        {
          paddingVertical: 20,
          paddingHorizontal: 16,
        },
      ),
    },
    list: {
      flexDirection: isDesktop ? 'row' : 'column',
    },
    listItem: {
      flexDirection: isDesktop ? 'column' : 'row',
      ...mediaOnly(
        DeviceSize.desktop,
        {
          flex: 1,
          marginRight: 30,
        },
        {
          marginBottom: 20,
        },
      ),
    },
    listItemLast: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          flex: 2,
          marginRight: 0,
        },
        {
          marginBottom: 0,
        },
      ),
    },
    listTitleText: {
      ...(isDesktop ? theme.fonts.h6 : theme.fonts.bodySmallLight),
      color: isDesktop ? theme.color.primaryColor : theme.color.labelText,
    },
    listItemTitle: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          marginBottom: 12,
        },
        {
          flexBasis: 74 * PixelRatio.getFontScale(),
          minWidth: 74 * PixelRatio.getFontScale(),
          marginRight: 26,
        },
      ),
    },
    listItemValue: {
      ...mediaOnly(
        DeviceSize.desktop,
        {},
        {
          flex: 1,
        },
      ),
    },
    listValueText: {
      ...(isDesktop
        ? {
            ...theme.fonts.h6Light,
            marginTop: 5,
          }
        : theme.fonts.body),
      color: theme.color.textColor,
    },
    listValueTextBold: {
      ...(isDesktop
        ? {
            ...theme.fonts.h3,
            marginBottom: 4,
          }
        : {
            ...theme.fonts.action,
          }),
      color: theme.color.textColor,
    },
    listValueTextSmall: {
      ...(isDesktop ? theme.fonts.bodySmallLight : theme.fonts.body),
      color: theme.color.labelText,
    },
  }));
  return (
    <View style={styles.container}>
      <View style={styles.list}>
        <View style={[styles.listItem, !eCardInfo.tariff && !eCardInfo.balance && styles.listItemLast]}>
          <View style={styles.listItemTitle}>
            <Text testID='card-info-id' style={styles.listTitleText} numberOfLines={1}>
              Карта:
            </Text>
          </View>
          <View style={styles.listItemValue}>
            <Text testID='card-number-id' style={styles.listValueTextBold}>
              {eCardInfo.eCardNumber}
            </Text>

            <Text testID='card-state-id' style={styles.listValueTextSmall}>
              {eCardInfo.stateCard ? eCardInfo.stateCard : 'срок действия истек'}
            </Text>
          </View>
        </View>
        {eCardInfo.balance && (
          <View style={[styles.listItem, !eCardInfo.tariff && styles.listItemLast]}>
            <View style={styles.listItemTitle}>
              <Text testID='card-balance-id' style={styles.listTitleText} numberOfLines={1}>
                Баланс:
              </Text>
            </View>
            <View style={styles.listItemValue}>
              <Text testID='card-balance-value-id' style={styles.listValueTextBold}>
                {eCardInfo.balance}
              </Text>
            </View>
          </View>
        )}
        {eCardInfo.tariff && (
          <View style={[styles.listItem, styles.listItemLast]}>
            <View style={styles.listItemTitle}>
              <Text testID='card-tarif-id' style={styles.listTitleText} numberOfLines={1}>
                Тариф:
              </Text>
            </View>
            <View style={styles.listItemValue}>
              <Text testID='card-tarif-value-id' style={styles.listValueText}>
                {eCardInfo.tariff}
              </Text>
            </View>
          </View>
        )}
      </View>
    </View>
  );
};
